import { Component, OnInit, Input } from "@angular/core";
import { UserSessionService } from "src/app/services/user-session/user-session.service";
import { Navigator } from "src/app/components/menu/navigator";
import { InappService } from "src/app/services/inapp/inapp.service";
import { PurchaseService } from "src/app/services/purchase/purchase.service";
import { Platform } from "@ionic/angular";
import { BoydRewardsService } from "src/app/services/boyd-rewards/boyd-rewards.service";
import { TransformOffersService } from "src/app/services/transform-offers/transform-offers.service"
import { EventsService } from "src/app/services/event/event.service";
import { ConfigService } from "src/app/services/config/config.service";
import { ProgressingService } from 'src/app/services/progressing/progressing.service';
import { CustomerModel } from "src/app/models/customer-model";

@Component({
  selector: "app-shop",
  templateUrl: "./shop-page.component.html",
  styleUrls: ["./shop-page.component.scss"],
})
export class ShopPageComponent implements OnInit {
  protected purchaseComplete: boolean = true;
  @Input() currentSelection: "shop" | "bonus" = "shop";
  private selected: any;
  private customer: any;
  public isAuthenticated: boolean = false;
  public isBoydUser = false;
  public selectedAssetsShop = "header-button-shop-boyd";
  public selectedAssetsBonus = "header-button-bonus";
  public isBonusInfoEnable = false;
  public cdnPath = this.config.getConfig().CDN_BASEURL + "/assets/imgs/";
  coinPurchases = [];
  private indexImg = 1;

  bonusPurchases = []
  public contentClass = ''

  constructor(
    public userSession: UserSessionService,
    private readonly navigator: Navigator,
    private inAppPurchase: InappService,
    private purchase: PurchaseService,
    private platform: Platform,
    public boydRewardsService: BoydRewardsService,
    private transformService: TransformOffersService,
    private eventService: EventsService,
    public config: ConfigService,
    private progressSerice: ProgressingService
  ) { }

  ngOnInit() {
    this.userSession.isAuthenticated().then((isAuthenticated) => {
      if (isAuthenticated) {
        this.isAuthenticated = true;
      }
    });

    this.contentClass = (this.platform.is('capacitor')) ? "no-scroll" : '';

   /* this.userSession.getCustomer().subscribe((customer) => {
      if (customer) {
        this.checkIsRewardsAvailable();
        this.customer = customer;
        this.isAuthenticated = true;
      }
    });*/
    this.userSession.getCustomerPromise().then((customer: CustomerModel) => {
      if (customer) {
        this.checkIsRewardsAvailable();
        this.customer = customer;
        this.isAuthenticated = true;
        this.getPurchases();
      }
    });
    //this.getPurchases();
    this.getAvailablePremiumBonus();
    this.userSession.getUserStatus().subscribe((userStatus) => {
      if (userStatus == null) this.isAuthenticated = false;
      else {
        this.isAuthenticated = true;
      }
    });

    this.eventService.subscribe("event:call:getpremium", () => {
      this.getAvailablePremiumBonus();
    })
  }

  ngOnDestroy() {
    // console.log("Destroying all events froms shop");
    this.eventService.destroy("event:call:getpremium");
  }

  onPremiumBonusClick() {
    this.isBonusInfoEnable = !this.isBonusInfoEnable
  }

  getAvailablePremiumBonus() {
    let customerBonus = [];
    this.purchase.getCustomerPremiumPurchases().subscribe((premiumCustomerPerchasRes) => {
      customerBonus = premiumCustomerPerchasRes.result ? premiumCustomerPerchasRes.payload : [];
      this.purchase.getPremiumPurchases().subscribe((premiumPerchasRes) => {
        if (premiumPerchasRes.result) {
          this.bonusPurchases = this.formatPremiumBonus(customerBonus, premiumPerchasRes.payload);
          if (this.platform.is('capacitor')) {
            this.bonusPurchases = this.transformService.transformOfferPrices(this.bonusPurchases);
          }
        }
      });
    });
  }

  protected formatPremiumBonus(customerBonus, aviableBonus) {
    customerBonus = customerBonus.filter(item => item.collects.some(collect => collect.status === "PENDING"));
    const payload = aviableBonus.map((bonusObj) => {
      const customerBonusItem = customerBonus.find((purchaseObj: any) => purchaseObj.premiumChipsDefinition.priceCode === bonusObj.priceCode);
      return customerBonusItem ? customerBonusItem : bonusObj;
    }).map(this.orderedValues);
    return payload;
  }

  protected orderedValues = (item) => {
    const bonusImages = ["prem_redbox", "prem_bluebox"];
    this.indexImg = 1 - this.indexImg;
    const isActiveBonus = (item && item.premiumChipsDefinition);
    const currentDay = isActiveBonus ? this.checkCurrentDate(item.collects) : null;
    return {
      ...item,
      totalDays: isActiveBonus ? item.premiumChipsDefinition.cycles : item.cycles,
      isActiveBonus: isActiveBonus,
      totalOf: !isActiveBonus ? item.chipsAmount * item.cycles : 0,
      leftImage: isActiveBonus ? 'prem_calender_coins' : bonusImages[this.indexImg],
      priceCode: isActiveBonus ? item.premiumChipsDefinition.priceCode : item.priceCode,
      startTime: isActiveBonus ? (currentDay && currentDay.startTime) ? currentDay.startTime : "" : "",
      currentDay: isActiveBonus ? (currentDay && currentDay.day) ? currentDay.day : "" : "",
      endTime: isActiveBonus ? (currentDay && currentDay.endTime) ? currentDay.endTime : "" : "",
    };
  }

  formatTimestamp(timestamp) {
    const date = new Date(timestamp);
    const formattedDate = date.toISOString();
    return formattedDate;
  }

  checkCurrentDate(collects) {
    const currentDate = this.formatTimestamp(Date.now());
    let currentDay;
    collects.sort((a, b) => a.day - b.day);
    for (let i = 0; i < collects.length; i++) {
      const collect = collects[i];
      const startDate = this.formatTimestamp(collect.startTime);
      const endDate = this.formatTimestamp(collect.endTime);
      if ((startDate <= endDate && currentDate <= endDate) &&
        (collect.status === "NOT_COLLECTED" || collect.status === "COLLECTED")) {
        currentDay = { ...collect };
        const nextDay = collects[i + 1];
        if (nextDay) {
          currentDay.startTime = nextDay.startTime;
        }
        break;
      } else if (startDate <= currentDate && currentDate <= endDate) {
        currentDay = { ...collect };
        break;
      }

    }
    return currentDay;
  }

  checkIsRewardsAvailable() {
    this.boydRewardsService.checkHasRewardCard().subscribe(
      (response: any) => {
        this.isBoydUser = response.result == 1 ? response.payload : false;
        this.changeAssets("shop");
      },
      (error) => {
        console.log("Error while getting response checkHasRewardCard ", error);
      }
    );
  }

  getPurchases() {
    if (this.isAuthenticated) {
      const apiCall$ = this.purchase.getAvailablePurchases();
      this.progressSerice.listenObservable(apiCall$);
      apiCall$.subscribe((res) => {
        if (res.result) {
          this.coinPurchases = this.formatPurchase(res.payload);
          if (this.platform.is('capacitor')) {
            this.coinPurchases = this.transformService.transformOfferPrices(this.coinPurchases);
          }
        }
      });
    }
  }

  formatPurchase(payload) {
    const imageStore = [
      "storecoin1",
      "storecoin2",
      "storecoin3",
      "storecoin4",
      "storecoin5",
      "storecoin6",
    ];

    const mapPayload = (data) => {
      return data.map((item, index) => {
        return {
          chips: item.chipsAmount,
          boydPoints: item.boydPoints,
          tierCredits: item.tierCredits,
          tag: item.tag,
          price: item.priceAmount,
          imageName: imageStore[index],
          priceCode: item.priceCode,
        };
      });
    };

    return mapPayload(payload);
  }

  onChange(selected) {
    this.currentSelection = selected;
    this.changeAssets(selected);
  }

  changeAssets(currentSelection) {
    if (currentSelection == "bonus") {
      this.selectedAssetsBonus = "header-button-bonus-selected";
      this.selectedAssetsShop = this.isBoydUser
        ? "header-button-shop-boyd"
        : "header-button-shop";
    } else {
      this.selectedAssetsBonus = "header-button-bonus";
      this.selectedAssetsShop = this.isBoydUser
        ? "header-button-shop-boyd-selected"
        : "header-button-shop-selected";
    }
  }
  onLearnMore() {
    return this.navigator.navigateTo("ShopComponent", {
      customModalClass: "fancy-modal",
      backdropDismiss: true,
    });
  }
}
